const CONTROL_ACCESS_EMAILS = ['g.centra.app@gmail.com'];

export const normalizeAccessEmail = (email = '') => String(email || '').trim().toLowerCase();

export const isControlAccessEmail = (email = '') => CONTROL_ACCESS_EMAILS.includes(normalizeAccessEmail(email));

export const buildControlUserProfile = (user = {}) => {
  const email = normalizeAccessEmail(user.email);

  return {
    uid: user.uid,
    email,
    role: 'architect',
    accessScope: 'internal',
    companyId: 'default',
    companyIds: ['default'],
    companyName: 'G-CENTRA',
    active: true,
    isArchitect: true,
    isSystemAdmin: true,
    architectAccess: true,
    internalAccess: true,
  };
};

export const canAccessControlPanel = (userData = null, authEmail = '') => {
  if (!userData && !authEmail) return false;

  const normalizedRole = String(userData?.role || '').toLowerCase().trim();
  const accessScope = String(userData?.accessScope || '').toLowerCase().trim();

  if (accessScope === 'company' || userData?.isTrialOwner) return false;
  if (isControlAccessEmail(authEmail) || isControlAccessEmail(userData?.email)) return true;

  const hasInternalFlag = Boolean(
    userData?.architectAccess ||
    userData?.internalAccess ||
    userData?.isArchitect ||
    userData?.isSystemAdmin
  );

  return (
    [
      'architect',
      'arquitecto',
      'arquitectura',
      'superadmin',
      'owner',
      'system_owner',
      'systemowner',
      'system-admin',
      'system_admin',
    ].includes(normalizedRole) || hasInternalFlag
  );
};
